export var HayDayItems = (function () {
    function HayDayItems() {
    }
    HayDayItems.getItemByName = function (name) {
        var matches = HAYDAYITEMS.filter(function (item) {
            if (item.name == name) {
                return true;
            }
            return false;
        });
        if (matches.length > 0) {
            return matches[0];
        }
        return null;
    };
    HayDayItems.getItemById = function (id) {
        // let matches = HAYDAYITEMS.filter(item => {
        //     if(item.id == id){
        //         return true;
        //     }
        //     return false;
        // });
        // if(matches.length > 0){
        //     return matches[0];
        // }
        // return null;
        // this is ok as long as id's stay in order
        return this.getItemByIndex(id);
    };
    Object.defineProperty(HayDayItems, "AllItems", {
        get: function () {
            return HAYDAYITEMS;
        },
        enumerable: true,
        configurable: true
    });
    HayDayItems.getItemByIndex = function (idx) {
        return HAYDAYITEMS[idx];
    };
    Object.defineProperty(HayDayItems, "Wheat", {
        get: function () {
            return HAYDAYITEMS[1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HayDayItems, "Egg", {
        get: function () {
            return HAYDAYITEMS[2];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HayDayItems, "None", {
        get: function () {
            return HAYDAYITEMS[0];
        },
        enumerable: true,
        configurable: true
    });
    return HayDayItems;
}());
export var HayDayItem = (function () {
    function HayDayItem(id, name, type, level, maxPrice, sprite) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.level = level;
        this.maxPrice = maxPrice;
        this.sprite = sprite;
        this.nameLower = name.toLowerCase();
    }
    return HayDayItem;
}());
export var HayDayItemType;
(function (HayDayItemType) {
    HayDayItemType[HayDayItemType["Crop"] = 0] = "Crop";
    HayDayItemType[HayDayItemType["Product"] = 1] = "Product";
    HayDayItemType[HayDayItemType["Tool"] = 2] = "Tool";
})(HayDayItemType || (HayDayItemType = {}));
export var HAYDAYITEMS = [
    new HayDayItem(0, 'Any'),
    new HayDayItem(1, 'Wheat', HayDayItemType.Crop, 1, 3, 'Wheat'),
    new HayDayItem(2, 'Egg', HayDayItemType.Product, 1, 18, 'Egg'),
    new HayDayItem(3, 'Corn', HayDayItemType.Crop, 2, 7, 'Corn'),
    new HayDayItem(4, 'Bread', HayDayItemType.Product, 2, 21, 'Bread'),
    new HayDayItem(5, 'Chicken feed', HayDayItemType.Product, 3, 7, 'Chicken_Feed'),
    new HayDayItem(6, 'Soybean', HayDayItemType.Crop, 5, 10, 'Soybean'),
    new HayDayItem(7, 'Cow feed', HayDayItemType.Product, 6, 14, 'Cow_Feed'),
    new HayDayItem(8, 'Milk', HayDayItemType.Product, 6, 32, 'Milk'),
    new HayDayItem(9, 'Cream', HayDayItemType.Product, 6, 50, 'Cream'),
    new HayDayItem(10, 'Sugarcane', HayDayItemType.Crop, 7, 14, 'Sugarcane'),
    new HayDayItem(11, 'Corn bread', HayDayItemType.Product, 7, 72, 'Corn_Bread'),
    new HayDayItem(12, 'Brown sugar', HayDayItemType.Product, 7, 32, 'Brown_Sugar'),
    new HayDayItem(13, 'Popcorn', HayDayItemType.Product, 8, 32, 'Popcorn'),
    new HayDayItem(14, 'Carrot', HayDayItemType.Crop, 9, 7, 'Carrot'),
    new HayDayItem(15, 'Butter', HayDayItemType.Product, 9, 82, 'Butter'),
    new HayDayItem(16, 'Pancake', HayDayItemType.Product, 9, 108, 'Pancake'),
    new HayDayItem(17, 'Pig feed', HayDayItemType.Product, 10, 14, 'Pig_Feed'),
    new HayDayItem(18, 'Bacon', HayDayItemType.Product, 10, 50, 'Bacon'),
    new HayDayItem(19, 'Cookie', HayDayItemType.Product, 10, 104, 'Cookie'),
    new HayDayItem(20, 'Bacon and eggs', HayDayItemType.Product, 11, 201, 'Bacon_and_Eggs'),
    new HayDayItem(21, 'Cheese', HayDayItemType.Product, 12, 122, 'Cheese'),
    new HayDayItem(22, 'Indigo', HayDayItemType.Crop, 13, 25, 'Indigo'),
    new HayDayItem(23, 'White sugar', HayDayItemType.Product, 13, 50, 'White_Sugar'),
    new HayDayItem(24, 'Carrot pie', HayDayItemType.Product, 14, 82, 'Carrot_Pie'),
    new HayDayItem(25, 'Pumpkin', HayDayItemType.Crop, 15, 32, 'Pumpkin'),
    new HayDayItem(26, 'Pumpkin pie', HayDayItemType.Product, 15, 158, 'Pumpkin_Pie'),
    new HayDayItem(27, 'Apple', HayDayItemType.Crop, 15, 39, 'Apple'),
    new HayDayItem(28, 'Wool', HayDayItemType.Product, 16, 54, 'Wool'),
    new HayDayItem(29, 'Sheep feed', HayDayItemType.Product, 16, 14, 'Sheep_Feed'),
    new HayDayItem(30, 'Buttered popcorn', HayDayItemType.Product, 16, 126, 'Buttered_Popcorn'),
    new HayDayItem(31, 'Sweater', HayDayItemType.Product, 17, 151, 'Sweater'),
    new HayDayItem(32, 'Cotton', HayDayItemType.Crop, 18, 28, 'Cotton'),
    new HayDayItem(33, 'Bacon pie', HayDayItemType.Product, 18, 219, 'Bacon_Pie'),
    new HayDayItem(34, 'Syrup', HayDayItemType.Product, 18, 90, 'Syrup'),
    new HayDayItem(35, 'Cotton fabric', HayDayItemType.Product, 18, 108, 'Cotton_Fabric'),
    new HayDayItem(36, 'Hamburger', HayDayItemType.Product, 18, 180, 'Hamburger'),
    new HayDayItem(37, 'Raspberry muffin', HayDayItemType.Product, 19, 140, 'Raspberry_Muffin'),
    new HayDayItem(38, 'Blue woolly hat', HayDayItemType.Product, 19, 111, 'Blue_Woolly_Hat'),
    new HayDayItem(39, 'Raspberry', HayDayItemType.Crop, 19, 46, 'Raspberry'),
    new HayDayItem(40, 'Cotton shirt', HayDayItemType.Product, 19, 241, 'Cotton_Shirt'),
    new HayDayItem(41, 'Blue sweater', HayDayItemType.Product, 20, 208, 'Blue_Sweater'),
    new HayDayItem(42, 'Carrot cake', HayDayItemType.Product, 21, 165, 'Carrot_Cake'),
    new HayDayItem(43, 'Woolly chaps', HayDayItemType.Product, 21, 309, 'Woolly_Chaps'),
    new HayDayItem(44, 'Cherry', HayDayItemType.Crop, 22, 68, 'Cherry'),
    new HayDayItem(45, 'Cream cake', HayDayItemType.Product, 23, 219, 'Cream_Cake'),
    new HayDayItem(46, 'Red berry cake', HayDayItemType.Product, 23, 255, 'Red_Berry_Cake'),
    new HayDayItem(47, 'Cheesecake', HayDayItemType.Product, 24, 284, 'Cheesecake'),
    new HayDayItem(48, 'Silver ore', HayDayItemType.Product, 24, 18, 'Silver_Ore'),
    new HayDayItem(49, 'Gold ore', HayDayItemType.Product, 24, 21, 'Gold_Ore'),
    new HayDayItem(50, 'Platinum ore', HayDayItemType.Product, 24, 32, 'Platinum_Ore'),
    new HayDayItem(51, 'Silver bar', HayDayItemType.Product, 24, 147, 'Silver_Bar'),
    new HayDayItem(52, 'Chili pepper', HayDayItemType.Product, 25, 36, 'Chili_Pepper'),
    new HayDayItem(53, 'Chili popcorn', HayDayItemType.Product, 25, 122, 'Chili_Popcorn'),
    new HayDayItem(54, 'Gold bar', HayDayItemType.Product, 25, 180, 'Gold_Bar'),
    new HayDayItem(55, 'Platinum bar', HayDayItemType.Product, 25, 205, 'Platinum_Bar'),
    new HayDayItem(56, 'Violet dress', HayDayItemType.Product, 25, 327, 'Violet_Dress'),
    new HayDayItem(57, 'Blackberry muffin', HayDayItemType.Product, 26, 226, 'Blackberry_Muffin'),
    new HayDayItem(58, 'Carrot juice', HayDayItemType.Product, 26, 46, 'Carrot_Juice'),
    new HayDayItem(59, 'Blackberry', HayDayItemType.Crop, 26, 82, 'Blackberry'),
    new HayDayItem(60, 'Fish fillet', HayDayItemType.Product, 27, 54, 'Fish_Fillet'),
    new HayDayItem(61, 'Fish burger', HayDayItemType.Product, 27, 226, 'Fish_Burger'),
    new HayDayItem(62, 'Apple pie', HayDayItemType.Product, 28, 270, 'Apple_Pie'),
    new HayDayItem(63, 'Fish pie', HayDayItemType.Product, 28, 226, 'Fish_Pie'),
    new HayDayItem(64, 'Apple juice', HayDayItemType.Product, 28, 129, 'Apple_Juice'),
    new HayDayItem(65, 'Vanilla ice cream', HayDayItemType.Product, 29, 172, 'Vanilla_Ice_Cream'),
    new HayDayItem(66, 'Tomato', HayDayItemType.Crop, 30, 43, 'Tomato'),
    new HayDayItem(67, 'Roasted tomatoes', HayDayItemType.Product, 30, 118, 'Roasted_Tomatoes'),
    new HayDayItem(68, 'Cherry juice', HayDayItemType.Product, 30, 216, 'Cherry_Juice'),
    new HayDayItem(69, 'Tomato juice', HayDayItemType.Product, 31, 162, 'Tomato_Juice'),
    new HayDayItem(70, 'Berry juice', HayDayItemType.Product, 31, 205, 'Berry_Juice'),
    new HayDayItem(71, 'Goat feed', HayDayItemType.Product, 32, 14, 'Goat_Feed'),
    new HayDayItem(72, 'Goat milk', HayDayItemType.Product, 32, 64, 'Goat_Milk'),
    new HayDayItem(73, 'Goat cheese', HayDayItemType.Product, 33, 162, 'Goat_Cheese'),
    new HayDayItem(74, 'Pizza', HayDayItemType.Product, 33, 190, 'Pizza'),
    new HayDayItem(75, 'Coal', HayDayItemType.Product, 33, 10, 'Coal'),
    new HayDayItem(76, 'Refined coal', HayDayItemType.Product, 33, 108, 'Refined_Coal'),
    new HayDayItem(77, 'Cherry popsicle', HayDayItemType.Product, 33, 352, 'Cherry_Popsicle'),
    new HayDayItem(78, 'Strawberry', HayDayItemType.Crop, 34, 50, 'Strawberry'),
    new HayDayItem(79, 'Feta pie', HayDayItemType.Product, 34, 223, 'Feta_Pie'),
    new HayDayItem(80, 'Iron ore', HayDayItemType.Product, 34, 14, 'Iron_Ore'),
    new HayDayItem(81, 'Iron bar', HayDayItemType.Product, 34, 129, 'Iron_Bar'),
    new HayDayItem(82, 'Strawberry ice cream', HayDayItemType.Product, 34, 331, 'Strawberry_Ice_Cream'),
    new HayDayItem(83, 'Potato', HayDayItemType.Crop, 35, 36, 'Potato'),
    new HayDayItem(84, 'Strawberry cake', HayDayItemType.Product, 35, 316, 'Strawberry_Cake'),
    new HayDayItem(85, 'Baked potato', HayDayItemType.Product, 35, 298, 'Baked_Potato'),
    new HayDayItem(86, 'Apple jam', HayDayItemType.Product, 35, 198, 'Apple_Jam'),
    new HayDayItem(87, 'Chocolate cake', HayDayItemType.Product, 36, 320, 'Chocolate_Cake'),
    new HayDayItem(88, 'Casserole', HayDayItemType.Product, 36, 367, 'Casserole'),
    new HayDayItem(89, 'Cacao', HayDayItemType.Crop, 36, 86, 'Cacao'),
    new HayDayItem(90, 'Raspberry jam', HayDayItemType.Product, 36, 230, 'Raspberry_Jam'),
    new HayDayItem(91, 'Spicy pizza', HayDayItemType.Product, 37, 226, 'Spicy_Pizza'),
    new HayDayItem(92, 'Blackberry jam', HayDayItemType.Product, 37, 388, 'Blackberry_Jam'),
    new HayDayItem(93, 'Potato feta cake', HayDayItemType.Product, 38, 309, 'Potato_Feta_Cake'),
    new HayDayItem(94, 'Cherry jam', HayDayItemType.Product, 38, 327, 'Cherry_Jam'),
    new HayDayItem(95, 'Bracelet', HayDayItemType.Product, 38, 514, 'Bracelet'),
    new HayDayItem(96, 'Potato bread', HayDayItemType.Product, 39, 284, 'Potato_Bread'),
    new HayDayItem(97, 'Shepherd\'s pie', HayDayItemType.Product, 39, 280, 'Shepherds_Pie'),
    new HayDayItem(98, 'Chocolate ice cream', HayDayItemType.Product, 39, 342, 'Chocolate_Ice_Cream'),
    new HayDayItem(99, 'Honeycomb', HayDayItemType.Product, 39, 68, 'Honeycomb'),
    new HayDayItem(100, 'Necklace', HayDayItemType.Product, 39, 727, 'Necklace'),
    new HayDayItem(101, 'Honey', HayDayItemType.Product, 39, 154, 'Honey'),
    new HayDayItem(102, 'Honey popcorn', HayDayItemType.Product, 40, 360, 'Honey_Popcorn'),
    new HayDayItem(103, 'Diamond ring', HayDayItemType.Product, 40, 824, 'Diamond_Ring'),
    new HayDayItem(104, 'Fish and chips', HayDayItemType.Product, 41, 244, 'Fish_and_Chips'),
    new HayDayItem(105, 'Iron bracelet', HayDayItemType.Product, 41, 658, 'Iron_Bracelet'),
    new HayDayItem(106, 'Coffee bean', HayDayItemType.Crop, 42, 64, 'Coffee_Bean'),
    new HayDayItem(107, 'Espresso', HayDayItemType.Product, 42, 248, 'Espresso'),
    new HayDayItem(108, 'Honey apple cake', HayDayItemType.Product, 42, 482, 'Honey_Apple_Cake'),
    new HayDayItem(109, 'Caffè latte', HayDayItemType.Product, 43, 219, 'Caffe_Latte'),
    new HayDayItem(110, 'Chocolate popcorn', HayDayItemType.Product, 44, 248, 'Chocolate_Popcorn'),
    new HayDayItem(111, 'Lobster tail', HayDayItemType.Product, 44, 201, 'Lobster_Tail'),
    new HayDayItem(112, 'Frutti di Mare pizza', HayDayItemType.Product, 45, 403, 'Frutti_di_Mare_Pizza'),
    new HayDayItem(113, 'Caffè mocha', HayDayItemType.Product, 45, 291, 'Caffe_Mocha'),
    new HayDayItem(114, 'Raspberry mocha', HayDayItemType.Product, 46, 259, 'Raspberry_Mocha'),
    new HayDayItem(115, 'Lobster soup', HayDayItemType.Product, 46, 612, 'Lobster_Soup'),
    new HayDayItem(116, 'Hot chocolate', HayDayItemType.Product, 47, 270, 'Hot_Chocolate'),
    new HayDayItem(117, 'Tomato soup', HayDayItemType.Product, 47, 478, 'Tomato_Soup'),
    new HayDayItem(118, 'Red scarf', HayDayItemType.Product, 48, 288, 'Red_Scarf'),
    new HayDayItem(119, 'Lobster skewer', HayDayItemType.Product, 48, 417, 'Lobster_Skewer'),
    new HayDayItem(120, 'Beeswax', HayDayItemType.Product, 48, 234, 'Beeswax'),
    new HayDayItem(121, 'Strawberry candle', HayDayItemType.Product, 48, 370, 'Strawberry_Candle'),
    new HayDayItem(122, 'Pumpkin soup', HayDayItemType.Product, 49, 392, 'Pumpkin_Soup'),
    new HayDayItem(123, 'Strawberry jam', HayDayItemType.Product, 50, 270, 'Strawberry_Jam'),
    new HayDayItem(124, 'Duck feather', HayDayItemType.Product, 50, 140, 'Duck_Feather'),
    new HayDayItem(125, 'Caramel apple', HayDayItemType.Product, 51, 255, 'Caramel_Apple'),
    new HayDayItem(126, 'Pillow', HayDayItemType.Product, 51, 676, 'Pillow'),
    new HayDayItem(127, 'Toffee', HayDayItemType.Product, 52, 176, 'Toffee'),
    new HayDayItem(128, 'Raspberry candle', HayDayItemType.Product, 52, 360, 'Raspberry_Candle'),
    new HayDayItem(129, 'Fish soup', HayDayItemType.Product, 53, 298, 'Fish_Soup'),
    new HayDayItem(130, 'Soy sauce', HayDayItemType.Product, 54, 154, 'Soy_Sauce'),
    new HayDayItem(131, 'Chocolate', HayDayItemType.Product, 54, 460, 'Chocolate'),
    new HayDayItem(132, 'Rice', HayDayItemType.Crop, 56, 18, 'Rice'),
    new HayDayItem(133, 'Sushi roll', HayDayItemType.Product, 56, 489, 'Sushi_Roll'),
    new HayDayItem(134, 'Olive', HayDayItemType.Crop, 57, 82, 'Olive'),
    new HayDayItem(135, 'Lollipop', HayDayItemType.Product, 57, 342, 'Lollipop'),
    new HayDayItem(136, 'Lettuce', HayDayItemType.Crop, 58, 32, 'Lettuce'),
    new HayDayItem(137, 'Feta salad', HayDayItemType.Product, 58, 745, 'Feta_Salad'),
    new HayDayItem(138, 'Lobster sushi', HayDayItemType.Product, 59, 637, 'Lobster_Sushi'),
    new HayDayItem(139, 'Blanket', HayDayItemType.Product, 59, 1098, 'Blanket'),
    new HayDayItem(140, 'Jelly beans', HayDayItemType.Product, 60, 684, 'Jelly_Beans'),
    new HayDayItem(141, 'Olive oil', HayDayItemType.Product, 60, 277, 'Olive_Oil'),
    new HayDayItem(142, 'Veggie bagel', HayDayItemType.Product, 61, 532, 'Veggie_Bagel'),
    new HayDayItem(143, 'BLT salad', HayDayItemType.Product, 62, 723, 'BLT_Salad'),
    new HayDayItem(144, 'Mayonnaise', HayDayItemType.Product, 62, 378, 'Mayonnaise'),
    new HayDayItem(145, 'Egg sushi', HayDayItemType.Product, 63, 550, 'Egg_Sushi'),
    new HayDayItem(146, 'Seafood salad', HayDayItemType.Product, 64, 763, 'Seafood_Salad'),
    new HayDayItem(147, 'Berry smoothie', HayDayItemType.Product, 64, 547, 'Berry_Smoothie'),
    new HayDayItem(148, 'Bacon toast', HayDayItemType.Product, 65, 648, 'Bacon_Toast'),
    new HayDayItem(149, 'Lemon', HayDayItemType.Crop, 66, 93, 'Lemon'),
    new HayDayItem(150, 'Lemon curd', HayDayItemType.Product, 66, 367, 'Lemon_Curd'),
    new HayDayItem(151, 'Egg sandwich', HayDayItemType.Product, 66, 583, 'Egg_Sandwich'),
    new HayDayItem(152, 'Green smoothie', HayDayItemType.Product, 66, 320, 'Green_Smoothie'),
    new HayDayItem(153, 'Fresh pasta', HayDayItemType.Product, 67, 43, 'Fresh_Pasta'),
    new HayDayItem(154, 'Pasta salad', HayDayItemType.Product, 67, 759, 'Pasta_Salad'),
    new HayDayItem(155, 'Lemon pie', HayDayItemType.Product, 67, 446, 'Lemon_Pie'),
    new HayDayItem(156, 'Onion', HayDayItemType.Crop, 68, 39, 'Onion'),
    new HayDayItem(157, 'Grilled Onion', HayDayItemType.Product, 68, 0, 'Grilled_Onion'),
    new HayDayItem(158, 'Lemon cake', HayDayItemType.Product, 68, 896, 'Lemon_Cake'),
    new HayDayItem(159, 'Tomato sauce', HayDayItemType.Product, 69, 230, 'Tomato_Sauce'),
    new HayDayItem(160, 'Honey toast', HayDayItemType.Product, 69, 255, 'Honey_Toast'),
    new HayDayItem(161, 'Yogurt smoothie', HayDayItemType.Product, 70, 349, 'Yogurt_Smoothie'),
    new HayDayItem(162, 'Cloche hat', HayDayItemType.Product, 70, 468, 'Cloche_Hat'),
    new HayDayItem(163, 'Orange', HayDayItemType.Crop, 71, 0, 'Orange'),
    new HayDayItem(164, 'Orange juice', HayDayItemType.Product, 71, 0, 'Orange_Juice'),
    new HayDayItem(165, 'Onion soup', HayDayItemType.Product, 72, 0, 'Onion_Soup'),
    new HayDayItem(166, 'Lemon candle', HayDayItemType.Product, 72, 457, 'Lemon_Candle'),
    new HayDayItem(167, 'Top hat', HayDayItemType.Product, 72, 619, 'Top_Hat'),
    new HayDayItem(168, 'Gnocchi', HayDayItemType.Product, 72, 475, 'Gnocchi'),
    new HayDayItem(169, 'Noodle soup', HayDayItemType.Product, 73, 432, 'Noodle_Soup'),
    new HayDayItem(170, 'Rice noodles', HayDayItemType.Product, 73, 100, 'Rice_Noodles'),
    new HayDayItem(171, 'Marmalade', HayDayItemType.Product, 74, 0, 'Marmalade'),
    new HayDayItem(172, 'Sun hat', HayDayItemType.Product, 74, 468, 'Sun_Hat'),
    new HayDayItem(173, 'Veggie lasagna', HayDayItemType.Product, 74, 532, 'Veggie_Lasagna'),
    new HayDayItem(174, 'Hot dog', HayDayItemType.Product, 75, 370, 'Hot_Dog'),
    new HayDayItem(175, 'Tofu dog', HayDayItemType.Product, 76, 367, 'Tofu_Dog'),
    new HayDayItem(176, 'Corn dog', HayDayItemType.Product, 78, 529, 'Corn_Dog'),
    new HayDayItem(177, 'Lobster pasta', HayDayItemType.Product, 79, 637, 'Lobster_Pasta'),
    new HayDayItem(178, 'Axe', HayDayItemType.Tool, 5, 0, 'Axe'),
    new HayDayItem(179, 'Bolt', HayDayItemType.Tool, 1, 0, 'Bolt'),
    new HayDayItem(180, 'Brick', HayDayItemType.Tool, 34, 0, 'Brick'),
    new HayDayItem(181, 'Duct Tape', HayDayItemType.Tool, 1, 0, 'Duct_Tape'),
    new HayDayItem(182, 'Dynamite', HayDayItemType.Tool, 5, 0, 'Dynamite'),
    new HayDayItem(183, 'Hammer', HayDayItemType.Tool, 34, 0, 'Hammer'),
    new HayDayItem(184, 'Hand Drill', HayDayItemType.Tool, 34, 0, 'Hand_Drill'),
    new HayDayItem(185, 'Land Deed', HayDayItemType.Tool, 22, 0, 'LandDeed'),
    new HayDayItem(186, 'Mallet', HayDayItemType.Tool, 22, 0, 'Mallet'),
    new HayDayItem(187, 'Map Piece', HayDayItemType.Tool, 34, 0, 'MapPiece'),
    new HayDayItem(188, 'Marker Stake', HayDayItemType.Tool, 22, 0, 'MarkerStake'),
    new HayDayItem(189, 'Nails', HayDayItemType.Tool, 1, 0, 'Nail'),
    new HayDayItem(190, 'Paint Bucket', HayDayItemType.Tool, 34, 0, 'Paint_Bucket'),
    new HayDayItem(191, 'Pickaxe', HayDayItemType.Tool, 34, 0, 'Pickaxe'),
    new HayDayItem(192, 'Plank', HayDayItemType.Tool, 1, 0, 'Plank'),
    new HayDayItem(193, 'Saw', HayDayItemType.Tool, 5, 0, 'Saw'),
    new HayDayItem(194, 'Screw', HayDayItemType.Tool, 1, 0, 'Screw'),
    new HayDayItem(195, 'Shovel', HayDayItemType.Tool, 5, 0, 'Shovel'),
    new HayDayItem(196, 'Stone Blocks', HayDayItemType.Tool, 34, 0, 'Stone_Block'),
    new HayDayItem(197, 'Tar Bucket', HayDayItemType.Tool, 34, 0, 'Tar_Bucket'),
    new HayDayItem(198, 'TNT Barrel', HayDayItemType.Tool, 5, 0, 'TNT'),
    new HayDayItem(199, 'Wood Panel', HayDayItemType.Tool, 1, 0, 'Wood_Panel'),
    new HayDayItem(200, 'Taco', HayDayItemType.Product, 77, 396, 'Taco'),
    new HayDayItem(201, 'Onion Dog', HayDayItemType.Product, 80, 306, 'Onion_Dog'),
    new HayDayItem(202, 'Orange Sorbet', HayDayItemType.Product, 78, 399, 'Orange_Sorbet'),
    new HayDayItem(203, 'Peach Ice Cream', HayDayItemType.Product, 83, 450, 'Peach_Ice_Cream'),
    new HayDayItem(204, 'Peach Jam', HayDayItemType.Product, 79, 464, 'Peach_Jam'),
    new HayDayItem(205, 'Peach Tart', HayDayItemType.Product, 76, 435, 'Peach_Tart'),
    new HayDayItem(206, 'Fruit Salad', HayDayItemType.Product, 82, 597, 'Fruit_Salad'),
    new HayDayItem(207, 'Summer Salad', HayDayItemType.Product, 84, 554, 'Summer_Salad'),
    new HayDayItem(208, 'Salsa', HayDayItemType.Product, 77, 252, 'Salsa'),
    new HayDayItem(209, 'Mixed Smoothie', HayDayItemType.Product, 88, 504, 'Mixed_Smoothie'),
    new HayDayItem(210, 'Fish Taco', HayDayItemType.Product, 79, 392, 'Fish_Taco'),
    new HayDayItem(211, 'Quesadilla', HayDayItemType.Product, 82, 241, 'Quesadilla'),
    new HayDayItem(212, 'Nachos', HayDayItemType.Product, 87, 432, 'Nachos'),
    new HayDayItem(213, 'Green Tea', HayDayItemType.Product, 80, 241, 'Green_Tea'),
    new HayDayItem(214, 'Milk Tea', HayDayItemType.Product, 81, 190, 'Milk_Tea'),
    new HayDayItem(215, 'Honey Tea', HayDayItemType.Product, 83, 313, 'Honey_Tea'),
    new HayDayItem(216, 'Lemon Tea', HayDayItemType.Product, 86, 241, 'Lemon_Tea'),
    new HayDayItem(217, 'Orange Tea', HayDayItemType.Product, 89, 255, 'Orange_Tea'),
    new HayDayItem(218, 'Iced Tea', HayDayItemType.Product, 92, 252, 'Iced_Tea')
];
